import BaseComponent from "../../../../../base/BaseComponent";
import React from "react";
import {Input,Button} from 'antd';
import MyIconSvg from "../../../components/svg/Svg";
import PropTypes from "prop-types";

export default class RelationshipMap extends BaseComponent {
    static defaultProps = {
        name: '周杰伦',
        count: 0,
        src: "/storage/3B15A5FE336A78A68B4571FE96973AB2",
        singleClick: () => {
        },
        doubleClick: () => {
        }
    };
    static propTypes = {
        name: PropTypes.array.isRequired,//传入dom 结构 名称
        src: PropTypes.string.isRequired,//图片
        count: PropTypes.number.isRequired,//数量
        doubleClick: PropTypes.func.isRequired,//双击函数
        singleClick: PropTypes.func.isRequired,//单击回调函数
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
            isShowInput: false
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {


    }

    componentWillMount() {

    }

    componentDidMount() {


    }

    handleEnter() {
        this.setState({hover: true})
    }

    handleOut() {
        this.setState({hover: false})
    }

    render() {
        // // 鼠标点击划过  公共
        let backgroundColor;
        if (this.state.hover) {
            backgroundColor = 'rgba(0, 80, 179, 0.04)';
        } else {
            backgroundColor = 'none';
        }
        let newSecondSelectColor =this.sysConfigGetValueByKey("NewMenuBg", "#0050B3")
        return (
            <div className={'faceModel'} style={{width: '168px', height: '168px', background: backgroundColor}}
                 onClick={() => {
                     this.props.singleClick && this.props.singleClick()
                 }}
                 onMouseEnter={() => this.handleEnter()}
                 onMouseLeave={() => this.handleOut()}>

                <img style={{
                    width: '104px',
                    height: '104px',
                    objectFit: 'cover',
                    borderRadius: '50%',
                    margin: '6px 32px'
                }} src={this.props.src}/>
                <div style={{marginLeft:'32px',display: this.props.isShowInput ? 'none' : 'block',}}>
                    {this.props.name && this.props.name.length ?
                        <div style={{textAlign: "center", display: this.props.isShowInput ? 'none' : 'block', margin: '0 auto'}}>
                           <span style={{fontSize: '14px', color: "rgba(0, 0, 0, 0.65)", marginRight: '3px',display: "inline-block", maxWidth:'85%'}}
                                 className={'twoText'}
                                 title={this.props.name && this.props.name.length ? this.props.name[0] : ''}
                               >
                            {this.props.name[0]}
                        </span>
                            <span style={{width: '14px', height: '14px',position: "relative",
                                top: "-3px",cursor:'pointer'}} onClick={() => {
                              this.props.editLabel && this.props.editLabel('edit')
                        }}>
                                <MyIconSvg type={"ReName"}  colors={[this.themeBgColor]}/>
                            </span></div> :
                        <Button style={{color: 'rgba(0, 0, 0, 0.45)'}} size={"small"} onClick={() => {
                            if (!this.props.name.length) {
                                this.props.doubleClick && this.props.doubleClick('add')
                            }
                        }}>设置人物名称</Button>}

                </div>
                <div style={{ display: this.props.isShowInput ? 'block' : 'none'}}>
                    <Input style={{width:'84px',marginLeft:'8px'}} size={'small'}
                           value={this.props.oldLabel ? this.props.oldLabel : ''}
                           onChange={(e) => {
                               this.props.onChangeText && this.props.onChangeText(e)
                           }}
                    />
                    <span style={{color:newSecondSelectColor,marginLeft:'8px',cursor:'pointer'}} onClick={()=>{
                        this.props.onPressEnter && this.props.onPressEnter()
                    }}>确定</span>
                    <span  style={{marginLeft:'8px',color:'rgba(0, 0, 0, 0.25)',cursor:'pointer'}} onClick={()=>{
                        this.props.close && this.props.close()
                    }}>取消</span>
                </div>
                <div style={{fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)', textAlign: 'center',marginTop:'4px'}}>
                    出现次数：{this.props.count}
                </div>
                <style>{`.faceModel .ant-btn{color:rgba(0, 0, 0, 0.45) !important;
                  .ant-input:focus, .ant-input:hover{border-color:${newSecondSelectColor}!important;
                
                }`}</style>

            </div>
        )
    }

    close = () => {
        this.setState({isShowInput: false})
    }

}